export default __webpack_public_path__ + "static/media/boardgameCentralImage2.56820ac7.png";